import React, { useEffect, useState } from "react";
import {
  Box, TextField, Button, Typography, CircularProgress, Paper, Grid,
  Alert, Switch, FormControlLabel, FormControl, InputLabel, Select, MenuItem
} from "@mui/material";
import { useAuthContext } from "../context/AuthContext";

const toInt = (v) => (v === "" || v == null ? null : Math.trunc(Number(v)));
const toNum = (v) => (v === "" || v == null ? null : Number(v));
const isPct = (n) => n == null || (n >= 0 && n <= 100);

const AddPipelineStageForm = ({ stageData, onClose, onSubmit, isLoading }) => {
  const { userData } = useAuthContext();
  const [errorMessage, setErrorMessage] = useState(null);

  const [form, setForm] = useState({
    ...stageData,
    nome: stageData?.nome || "",
    ordem: stageData?.ordem ?? "",
    probabilidade: stageData?.probabilidade ?? "",
    cor: stageData?.cor || "#607D8B",
    tipo: stageData?.tipo || "normal", // normal | ganho | perdido
    sla_dias: stageData?.sla_dias ?? "",
    status: stageData?.status == null ? 1 : Number(stageData.status),
    id_usuario: stageData?.id_usuario || userData?.id,
    id_usuario_ultima_alteracao: userData?.id,
  });

  useEffect(() => {
    setForm((p) => ({
      ...p,
      ...stageData,
      nome: stageData?.nome || "",
      ordem: stageData?.ordem ?? "",
      probabilidade: stageData?.probabilidade ?? "",
      cor: stageData?.cor || "#607D8B",
      tipo: stageData?.tipo || "normal",
      sla_dias: stageData?.sla_dias ?? "",
      status: stageData?.status == null ? 1 : Number(stageData.status),
      id_usuario: stageData?.id_usuario || userData?.id,
      id_usuario_ultima_alteracao: userData?.id,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stageData?.id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((p) => ({ ...p, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage(null);

    const ordem = toInt(form.ordem);
    const prob  = toNum(form.probabilidade);
    const sla   = toInt(form.sla_dias);

    if (!form.nome.trim()) {
      setErrorMessage("Informe o nome da etapa.");
      return;
    }
    if (!isPct(prob)) {
      setErrorMessage("Probabilidade deve estar entre 0 e 100%.");
      return;
    }

    const payload = {
      id: form.id,
      nome: form.nome.trim(),
      ordem,
      probabilidade: prob,
      cor: form.cor || "#607D8B",
      tipo: form.tipo, // normal | ganho | perdido
      sla_dias: sla,
      status: Number(form.status) === 1 ? 1 : 0,
      id_usuario: form.id_usuario || userData?.id,
      id_usuario_ultima_alteracao: userData?.id,
    };

    try {
      await onSubmit(payload);
    } catch (err) {
      setErrorMessage(err?.response?.data?.message || "Erro ao salvar a etapa.");
    }
  };

  return (
    <Paper elevation={3} sx={{ padding: 3, width: "95%", margin: "0 auto" }}>
      <Typography variant="h6" gutterBottom>
        {form?.id ? "Editar Etapa" : "Adicionar Etapa"}
      </Typography>

      {errorMessage && (
        <Box sx={{ mb: 2 }}>
          <Alert severity="error">{errorMessage}</Alert>
        </Box>
      )}

      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              label="Nome *"
              name="nome"
              value={form.nome}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              label="Ordem"
              name="ordem"
              value={form.ordem ?? ""}
              onChange={handleChange}
              inputMode="numeric"
              fullWidth
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              label="Probabilidade (%)"
              name="probabilidade"
              type="number"
              inputProps={{ step: "1", min: "0", max: "100" }}
              value={form.probabilidade}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              label="Cor"
              name="cor"
              type="color"
              InputLabelProps={{ shrink: true }}
              value={form.cor}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <FormControl fullWidth>
              <InputLabel>Tipo</InputLabel>
              <Select
                label="Tipo"
                name="tipo"
                value={form.tipo}
                onChange={handleChange}
              >
                <MenuItem value="normal">Normal</MenuItem>
                <MenuItem value="ganho">Ganho</MenuItem>
                <MenuItem value="perdido">Perdido</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              label="SLA (dias)"
              name="sla_dias"
              type="number"
              inputProps={{ step: "1", min: "0" }}
              value={form.sla_dias}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} md={3} sx={{ display: "flex", alignItems: "center" }}>
            <FormControlLabel
              control={
                <Switch
                  checked={Number(form.status) === 1}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, status: e.target.checked ? 1 : 0 }))
                  }
                />
              }
              label={Number(form.status) === 1 ? "Ativa" : "Inativa"}
            />
          </Grid>
        </Grid>

        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 3 }}>
          <Button variant="outlined" onClick={onClose} disabled={isLoading}>
            Cancelar
          </Button>
          <Button type="submit" variant="contained" disabled={isLoading}>
            {isLoading ? <CircularProgress size={20} color="inherit" /> : "Salvar"}
          </Button>
        </Box>
      </form>
    </Paper>
  );
};

export default AddPipelineStageForm;
